const fsControl = (size) => {
  return size * 16 * 0.9;
};

const dpControl = (size) => {
  return size;
};

export { fsControl, dpControl };
